var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SigneGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 16 A 1.50015 1.50015 0 1 0 8.5 19 L 39.5 19 A 1.50015 1.50015 0 1 0 39.5 16 L 8.5 16 z M 8.5 28 A 1.50015 1.50015 0 1 0 8.5 31 L 39.5 31 A 1.50015 1.50015 0 1 0 39.5 28 L 8.5 28 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SigneGal);
export default __webpack_public_path__ + "static/media/icons8-signe-égal.44a2415b9238fdb396662bd790833e17.svg";
export { ForwardRef as ReactComponent };